import PropTypes from 'prop-types';

export default {
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  selectedRoute: PropTypes.object,
  selectedTrip: PropTypes.object,
  toggleRoutes: PropTypes.func,
  relationshipType: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  general: PropTypes.object,
  getPassengerDetails: PropTypes.func,
  showDate: PropTypes.bool,
  classes: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/containers/passengers/desktop/PassengersDesktopProps.js